import React from 'react';
import { Lock } from 'lucide-react';

const NoAccess: React.FC = () => (
  <div className="max-w-xl mx-auto mt-16 p-6 text-center bg-white border rounded-lg">
    <Lock className="w-8 h-8 mx-auto text-gray-400 mb-3" />
    <h2 className="text-lg font-semibold text-gray-900">Sem acesso a esta tela</h2>
    <p className="text-sm text-gray-500 mt-1">
      O seu cargo não inclui este módulo. Fale com um administrador da organização.
    </p>
  </div>
);

export default NoAccess;
